<div class="profile-detail">
    <div class="profile-title">
        <div class="profile-text">
            <h4 class=" d-lg-none d-flex ">Profile</h4>
            <h4 class="d-lg-flex d-none">Personal Details</h4>
        </div>
    </div>
    <div class="profile-upload-image">
        <input #file type="file" name="profile_picture" (change)="selectProfileImage($event)"
            accept="image/png, image/gif, image/jpeg" id="profile_picture" class="form-control ">
        <span>
            <img [src]="profile_pic ? profile_pic : 'assets/images/new-profile-icon.png'">
        </span>
    </div>
    <form class="profile-form-detail" [formGroup]="userProfileForm">
        <div class="row">
            <div class="col-12 d-lg-none d-md-flex">
                <div class="mb-4 w-100">
                    <label>Email *</label>
                    <input formControlName="email" type="email" placeholder="Enter email">
                    <div *ngIf="userProfileForm.controls['email'].touched && userProfileForm.controls['email'].invalid"
                        class="alert alert-danger alert-text">
                        <div
                            *ngIf="userProfileForm.controls['email'].errors && userProfileForm.controls['email'].errors['required']">
                            Email is
                            required.</div>
                        <div *ngIf="userProfileForm.controls['email'].hasError('pattern')">
                            Email is invalid.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="mb-4">
                    <label>First Name</label>
                    <input formControlName="first_name" name="first_name" type="text" placeholder="Enter first name">
                </div>
            </div>
            <div class="col-6">
                <div class="mb-4">
                    <label>Last Name</label>
                    <input formControlName="last_name" name="last_name" type="text" placeholder="Enter last name">
                </div>
            </div>
            <div class="col-6">
                <div class="mb-4">
                    <label>Phone Number *</label>
                    <input maxlength="10" formControlName="alternet_phone_number" name="alternet_phone_number"
                        type="text" placeholder="Enter phone number" readonly
                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');">
                    <div *ngIf="userProfileForm.controls['alternet_phone_number'].touched && userProfileForm.controls['alternet_phone_number'].invalid"
                        class="alert alert-danger alert-text">
                        <div
                            *ngIf="userProfileForm.controls['alternet_phone_number'].errors && userProfileForm.controls['alternet_phone_number'].errors['required']">
                            Phone number is
                            required.</div>
                    </div>
                </div>
            </div>
            <div class="col-6 d-lg-block d-none">
                <div class="mb-4">
                    <label>Email *</label>
                    <input formControlName="email" type="text" placeholder="Enter email">
                    <div *ngIf="userProfileForm.controls['email'].touched && userProfileForm.controls['email'].invalid"
                        class="alert alert-danger alert-text">
                        <div
                            *ngIf="userProfileForm.controls['email'].errors && userProfileForm.controls['email'].errors['required']">
                            Email is
                            required.</div>
                        <div *ngIf="userProfileForm.controls['email'].hasError('pattern')">
                            Email is invalid.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 ">
                <div class="mb-4">
                    <label>Age</label>
                    <input formControlName="age" type="text" placeholder="Enter age" name="age"
                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');">
                </div>
            </div>
            <div class="col-6 d-lg-block d-none">
                <span class="gener-name">Gender</span>
                <div class="p-relative" (click)="genderDropdown()">
                    <div class="gender-menu">
                        <div class="gender-detail">
                            {{selectedGender == 2 ? 'Female' : selectedGender == 1 ? 'Male' : selectedGender == 0 ? 'Other' : 'Select'}}
                        </div>
                    </div>
                    <div class="gender-select-new cursor-style">
                        <ul>
                            <li [ngClass]="selectedGender == 2 ? 'active' : ''" (click)="selectGender(2)">Female</li>
                            <li [ngClass]="selectedGender == 1 ? 'active' : ''" (click)="selectGender(1)">male</li>
                            <li [ngClass]="selectedGender == 0 ? 'active' : ''" (click)="selectGender(0)">other</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row d-lg-none d-md-flex">
                    <label>Gender</label>
                    <div class="col-4">
                        <div class="button " (click)="selectGender(2)">
                            <input class="cursor-pointer" type="radio" [id]="2" name="gender"
                                [checked]="selectedGender == 2" />
                            <label class="btn btn-default" [for]="2">Female</label>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="button " (click)="selectGender(1)">
                            <input class="cursor-pointer" type="radio" [id]="1" name="gender"
                                [checked]="selectedGender == 1" />
                            <label class="btn btn-default" [for]="1">Male</label>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="button " (click)="selectGender(0)">
                            <input class="cursor-pointer" type="radio" [id]="0" name="gender"
                                [checked]="selectedGender == 0" />
                            <label class="btn btn-default" [for]="0">Others</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button class="save-btn" (click)="updateProfile()" [ngClass]="{'no-pointer-events': isLoading, '': !isLoading}"> <i *ngIf="isLoading" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoading, '': !isLoading}"></i> Save</button>
    </form>
    <div class="profile-my-address d-lg-none d-md-block">
        <div class="profile-inner-title">
            <h4>My Addresses</h4>
            <a data-bs-target="#add-new-address" (click)="addUpdateAddress('edit',defaultAddress)">ADD/EDIT</a>
            <ng-template #noEdit>
            </ng-template>
        </div>
        <div class="billing-detail" *ngIf="defaultAddress">
            <span>Billing Address</span>
            <address>{{defaultAddress?.address_line1}}</address>
            <div class="state">{{defaultAddress && defaultAddress.city ? defaultAddress?.city : ''}} {{defaultAddress &&
                defaultAddress?.state_name ? ','+defaultAddress.state_name : ''}}</div>
        </div>
        <div class="billing-detail" *ngIf="!defaultAddress">
            <span>No address Available</span>
        </div>
    </div>
    <div class="better">Let’s Get to know you better</div>
    <div class="help">This helps us personalise FOR YOU</div>
</div>

<!-- skin-detail section start  -->
<div class="skin-detail-box"
    *ngIf="skinDetailList && (skinDetailList?.skinTypeList?.length > 0 || skinDetailList?.skinConcernList?.length > 0)">
    <span class="skin-detail-title">SKin Details</span>

    <div class="skin-detail" *ngIf="skinDetailList && skinDetailList?.skinTypeList?.length > 0">
        <span>SKin Type</span>
        <ul class="no-scrollbar">
            <li (click)="selectSkinType(skinType?.id + '_' + skinType?.name)"
                *ngFor="let skinType of skinDetailList?.skinTypeList;let i = index"
                [ngClass]="skinJson && skinJson.skinType && skinJson?.skinType.length > 0 && ''+skinJson?.skinType[0]?.id == ''+skinType?.id ? 'active' : ''">
                <a>{{skinType?.name}}</a>
            </li>
        </ul>
    </div>
    <div class="skin-detail" *ngIf="skinDetailList && skinDetailList?.skinConcernList?.length > 0">
        <div class="skin-detail-text">
            <span>Skin Concern</span>
            <div class="skin-text">You can select Multiple</div>
        </div>
        <ul class="no-scrollbar">
            <li (click)="selectSkinConcern(skinConcern?.id + '_' + skinConcern?.name)"
                *ngFor="let skinConcern of skinDetailList?.skinConcernList;let i = index"
                [ngClass]="skinJson && skinJson.skinConcern && skinJson.skinConcern.skinConcern1 && skinJson.skinConcern.skinConcern1.length > 0  && skinConcern1.indexOf(''+skinConcern?.id) != -1  ? 'active' : ''">
                <a>
                    <div class="right-arrow-icon"><img src="assets/images/check-arrow-profile.svg" alt="icon">
                    </div>
                    <div class="plus-arrow-icon"><img src="assets/images/plus-icon-profile.svg" alt="icon">
                    </div>
                    {{skinConcern?.name}}
                </a>
            </li>
        </ul>
    </div>
</div>
<div class="skin-detail-box  hair-detail-box"
    *ngIf="hairDetailList && (hairDetailList?.skinTypeList?.length > 0 || hairDetailList?.skinConcernList?.length > 0)">
    <span class="skin-detail-title">Hair Details</span>
    <div class="skin-detail" *ngIf="hairDetailList && hairDetailList?.skinTypeList?.length > 0">
        <span>Hair Type</span>
        <ul class="no-scrollbar">
            <li (click)="selectHairType(skinType?.id + '_' + skinType?.name)"
                *ngFor="let skinType of hairDetailList?.skinTypeList;let i = index"
                [ngClass]="hairJson && hairJson.skinType && hairJson.skinType.length > 0  && ''+hairJson?.skinType[0]?.id ==  ''+skinType?.id ? 'active' : ''">
                <a>{{skinType?.name}}</a>
            </li>
        </ul>
    </div>
    <div class="skin-detail" *ngIf="hairDetailList && hairDetailList?.skinConcernList?.length > 0">
        <span>Primary hair Concern</span>
        <ul class="no-scrollbar">
            <li (click)="selectHairConcern(skinConcern?.id + '_' + skinConcern?.name)"
                *ngFor="let skinConcern of hairDetailList?.skinConcernList;let i = index"
                [ngClass]="hairJson && hairJson.skinConcern && hairJson.skinConcern.hairConcern2 && hairJson.skinConcern.hairConcern2.length > 0  && hairConcern1.indexOf(''+skinConcern?.id) != -1 ? 'active' : ''">
                <a>{{skinConcern?.name}}</a>
            </li>
        </ul>
    </div>
</div>

<div class=" make-up-detail-box"
    *ngIf="makeUpJson && makeupDetailsAvailable && makeupDetailList && makeupDetailList.subCategoryList && makeupDetailList.subCategoryList.length > 0">
    <span>Make up Details</span>
    <div class="bg-mobile">
        <div class="make-up-detail" *ngFor="let subCat of makeupDetailList.subCategoryList; let i = index;">
            <div class="profile-form-detail make-up-m"
                *ngIf="makeUpJson && makeUpJson[subCat?.name] &&  makeUpJson[subCat?.name].length > 0">
                <span class="text-title">{{subCat?.name}}</span>
                <div class="row align-items-end" *ngFor="let att of makeUpJson[subCat?.name];let k = index;">
                    <div class="col-sm-8 col-12">
                        <div class="row">
                            <div class="col-6" *ngFor="let at of att; let j = index">
                                <div>
                                    <label>{{at.key}}</label>
                                    <input type="text" placeholder="type here" [(ngModel)]="at.value"
                                        [value]="at.value">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-12">
                        <div class="add-btn">
                            <button
                                *ngIf="k == makeUpJson[subCat?.name].length - 1 && makeUpJson[subCat?.name].length > 1"
                                (click)="updateMakeupDetail(subCat?.name)"> Update</button>
                            <button *ngIf="k != makeUpJson[subCat?.name].length - 1" (click)="delete(subCat?.name,k)">
                                Delete</button>
                            <button *ngIf="k == makeUpJson[subCat?.name].length - 1" (click)="addMore(subCat?.name)"> +
                                Add</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- skin-detail section start  -->

<div class="modal fade address-detail" id="add-new-address" tabindex="-1" aria-labelledby="addNewAddressLabel"
    aria-hidden="true">
    <app-add-address  [addressData]="defaultAddress" [viewForm]="viewForm" [from]="'profile'"
        (saveClickProfile)="saveNewAddress($event)"></app-add-address>
</div>

<div class="modal fade" id="email-update-profile" tabindex="-1" aria-labelledby="emailModalLabel" aria-hidden="true">
    <div class="add-new-address-model">
        <div class="modal-dialog" >
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-header py-0 d-lg-flex d-none   justify-content-end">
                        <button class="modal-button" type="button" data-bs-dismiss="modal" aria-label="Close"><img src="/assets/images/close-icon.png" alt="close" (click)="closeModal()"></button>
                    </div>
                    <div class="address-modal-title">
                        <h4>Email</h4>
                    </div>
                    <form class="add-new-address-detail" [formGroup]="emailFormgroup" (ngSubmit)="onSubmitEmail()">
                       
                        <div class="add-new-address-detail-input row">
                           
                            <div class="mb-3 col-lg-12 col-md-12 email-text">
                                <label>Email</label>
                                <input type="email" formControlName="email" placeholder="Email">
                                <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger alert-text">
                                    <div *ngIf="f['email'].errors && f['email'].errors['required']">Email is
                                      required.</div>
                                    <div *ngIf="f['email'].hasError('pattern')">
                                      Email is invalid.
                                    </div>
                                  </div>
                            </div>
                            <ul class="save-and-close new-save-btn d-lg-block d-none">
                                <li><button type="submit" class="save-dark" >Save Details</button></li>
                            </ul>
                        </div>
                        <ul class="save-and-close d-lg-none d-flex">
                            <li><button type="submit" class="save-dark" >Save Details</button></li>
                            <li><button class="cancel-border" data-bs-dismiss="modal" 
                                (click)="closeModal();" aria-label="Close">Cancel</button></li>
                        </ul>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>